import BufferReader from './bufferReader';
import {Subject} from 'rxjs';
import { Session } from '../user/model/interfaces';


export type SocketEvent = {
  name: 'onReceiveFinger';
  packet: BufferReader;
};

export enum SOCKET_CONNECTION_STATE {
  CONNECTING,
  OPEN,
  CLOSING,
  CLOSED,
}


export interface ISocketClient {
  subscirbe(...args: any): void;
  login(name: string, session: string): void;
  sendPacket(dataArray: any): void;
  connect(config: Session, onOpen?: () => void): string;
  connectDefault(): void;
  closeConnection(): void;
  isConnectedToDefault(): boolean;
  isConnectedTo(host: string, port: number): boolean;
  onConnect: Subject<Session>;
  setDefaultConnection(config: Session): void;
  isConnected(): boolean;
}
